import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useUpdate } from "@/hooks/queries";
import { useSidePanel } from "@/modules/side-panel";

import DissociateComponent from "./Dissociate";
import { getFieldTranslationKey } from "./DissociateUtils";

const useInterventionDissociate = ({
  interventionModel,
  dissociateField,
  dissociateModel,
  invalidateKeys,
}) => {
  const { t } = useTranslation();
  const { closeSidePanel } = useSidePanel();
  const {
    mutate,
    isPending: isLoading,
    isError,
    reset,
  } = useUpdate("interventions", interventionModel.id, {
    invalidateKeys,
  });

  const questionText = useMemo(() => {
    const fieldKey = getFieldTranslationKey(dissociateField);
    return t(`intervention:dissociate:question:${fieldKey}`, {
      intervention: interventionModel.name,
      [fieldKey]: dissociateModel.name,
    });
  }, [dissociateField, dissociateModel, interventionModel]);

  const dissociateIntervention = () => {
    const data = { [dissociateField]: null };
    mutate(data, { onSuccess: closeSidePanel });
  };

  return {
    questionText,
    buttonText: t("global:dissociate"),
    onDissociateClick: dissociateIntervention,
    onAlertCloseClick: reset,
    isLoading,
    isError,
  };
};

const InterventionDissociate = (props) => {
  const componentProps = useInterventionDissociate(props);

  return <DissociateComponent {...componentProps} />;
};

export default InterventionDissociate;
